<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="clearfix"></div>
<form [formGroup]="maintenanceForm" (ngSubmit)="maintenance()">
<div class="page-title">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="h2" style="color: #000; font-weight: 600">
          Maintenance Request
        </h1>
        <p>
          In order to serve your needs quickly and most accurately, We request
          that any service requests be made in writing via email. If you do not
          have access to a computer, or if it is an after hours call of an
          emergency nature, Please call our main number 248-366-8484 to be
          directed to our maintenance department.
        </p>
      </div>
    </div>
  </div>
</div>
<section class="find-property-css">
  <div class="container">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label>Property Address</label>
            <input type="text" class="form-control" formControlName="property"/>
            <ngb-alert [dismissible]="false" [type]="'danger'"
            *ngIf="maintenanceForm.get('property')?.dirty && maintenanceForm.get('property')?.invalid" class="text-left">
            <div *ngIf="maintenanceForm.get('property')?.errors?.required">Property Address is required.</div>
          </ngb-alert>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label>Tenant Name</label>
            <input type="text" class="form-control" formControlName="name"/>
            <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="maintenanceForm.get('name')?.dirty && maintenanceForm.get('name')?.invalid" class="text-left">
                    <div *ngIf="maintenanceForm.get('name')?.errors?.required"> Tenant Name is required.</div>
                  </ngb-alert>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label>Phone Number</label>
            <input type="text" class="form-control" formControlName="contact" mask="000-000-0000" [showMaskTyped]="false" />
            <ngb-alert [dismissible]="false" [type]="'danger'"
            *ngIf="maintenanceForm.get('contact')?.dirty && maintenanceForm.get('contact')?.invalid" class="text-left">
            <div *ngIf="maintenanceForm.get('contact')?.errors?.required">Phone is required.</div>
            <div *ngIf="maintenanceForm.get('contact')?.errors?.mask">Phone number is invalid.</div>
        </ngb-alert>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label>Email Address</label>
            <input type="email" class="form-control" formControlName="email"/>
            <ngb-alert [dismissible]="false" [type]="'danger'"
            *ngIf="maintenanceForm.get('email')?.dirty && maintenanceForm.get('email')?.invalid" class="text-left">
                    <div *ngIf="maintenanceForm.get('email')?.errors?.pattern">Email is invalid.</div>
                    <div *ngIf="maintenanceForm.get('email')?.errors?.required">Email is required.</div>
                  </ngb-alert>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="form-group" >
            <label>Problem</label>
            <input type="text" class="form-control" formControlName="problem"/>
            <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="maintenanceForm.get('problem')?.dirty && maintenanceForm.get('problem')?.invalid"
                    class="text-left">
                    <div *ngIf="maintenanceForm.get('problem')?.errors?.required">problem is required.</div>
                </ngb-alert>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label>Best Time To Call</label>
            <input type="text" class="form-control " formControlName="time"/>
            <ngb-alert [dismissible]="false" [type]="'danger'"
                    *ngIf="maintenanceForm.get('time')?.dirty && maintenanceForm.get('time')?.invalid" class="text-left">
                    <div *ngIf="maintenanceForm.get('time')?.errors?.required">call is required.</div>
                  </ngb-alert>
          </div>
        </div>
      </div>
        <button class="btn btn-theme" type="submit">Send Request</button>
      </div>
    </div>
</section>


